module.exports = __webpack_public_path__ + "static/media/modal-closer.7a380829.svg";